import CustomText from "@components/CustomText";
import React, { memo } from "react";
import { View, StyleSheet } from "react-native";
import { meta, IssueKeys } from "@constants/cplp";

const IssueTags = ({ current_state }) => {
  const currentState = current_state || {};

  return (
    <>
      {IssueKeys.map((key) =>
        currentState[key] ? (
          <View key={key} style={styles.container}>
            <CustomText variant="caption_1" style={styles.text}>
              {`${currentState[key]}`}
            </CustomText>
            <CustomText variant="caption_4" style={styles.text}>
              {` ${meta[key]}`}
            </CustomText>
          </View>
        ) : null,
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(255, 46, 0, 0.10)",
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingVertical: 2,
    marginVertical: 4,
    marginRight: 4,
    flexDirection: "row",
  },
  text: { color: "rgba(255, 46, 0, 1)", lineHeight: 18 },
});

export default memo(IssueTags);
